import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionWrapperProps {
  id?: string;
  children: ReactNode;
  className?: string;
  background?: 'white' | 'gray' | 'primary';
  'aria-labelledby'?: string;
}

export function SectionWrapper({
  id,
  children,
  className,
  background = 'white',
  'aria-labelledby': ariaLabelledBy,
}: SectionWrapperProps) {
  const bgClasses = {
    white: 'bg-white',
    gray: 'bg-secondary',
    primary: 'bg-primary/10',
  };

  return (
    <section
      id={id}
      className={cn('py-16 md:py-24', bgClasses[background], className)}
      aria-labelledby={ariaLabelledBy}
    >
      <div className="container mx-auto px-4">
        {children}
      </div>
    </section>
  );
}

export default SectionWrapper;
